import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import { isMenuOpenAtom } from "../../stores/Navigation";
import Embed from "../Embed";
import Inspect from "../Inspect";
import { NotFound } from "../NotFound";
import { PaperV1 } from "../PaperV1";
import { PaperV2 } from "../PaperV2";

import "./style.scss";

function App() {
  const isMenuOpen = useAtomValue(isMenuOpenAtom);

  // Update the body class to show/hide the menu.
  useEffect(() => {
    document.body.classList.toggle("menu-open", isMenuOpen);
  }, [isMenuOpen]);

  // Delay adding the "loaded" class to avoid animations on page load.
  useEffect(() => {
    setTimeout(() => {
      document.body.classList.toggle("loaded", true);
    }, 1);
  }, []);

  // Add tracking script in production only.
  useEffect(() => {
    const scriptUrl = "https://cloud.umami.is/script.js";
    const websiteId = "565f87a2-2f73-4bf3-8842-e5002701307c";
    const isProduction = window.location.hostname === "peterlai.github.io";
    const hasLoadedScript = document.querySelector(`script[src='${scriptUrl}']`);
    const isInIframe = () => window.self !== window.top;
    if (isProduction && !hasLoadedScript && !isInIframe()) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.setAttribute("data-website-id", websiteId);
      script.defer = true;
      document.head.appendChild(script);
    } else return;
  }, []);

  return (
    <HashRouter>
      <Header />
      <article>
        <Routes>
          <Route path="/" element=<PaperV2 /> />
          <Route path="/v1" element=<PaperV1 /> />
          <Route path="/v2" element=<PaperV2 /> />
          <Route path="/samples/:modelId/:sampleId/:featureKey?" element=<Inspect /> />
          <Route path="/embedded/:modelId/:sampleId/:featureKey?" element=<Embed /> />
          <Route path="*" element=<NotFound /> />
        </Routes>
      </article>
      <Menu />
    </HashRouter>
  );
}

export default App;
